// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DocumentSort_wrapper__ZERCh"};